import { useTranslation } from "@outschool/localization";
import { onlineClassesPath } from "@outschool/routes";

import animalsImage from "../../../images/hobby-topics/animals.png";
import artImage from "../../../images/hobby-topics/art.png";
import chessImage from "../../../images/hobby-topics/chess.png";
import codeImage from "../../../images/hobby-topics/coding.png";
import cookingImage from "../../../images/hobby-topics/cooking.png";
import sportsImage from "../../../images/hobby-topics/movement.png";
import performanceImage from "../../../images/hobby-topics/performance.png";
import travelImage from "../../../images/hobby-topics/travel.png";
import { Topic, TopicsShowcase } from "../TopicsShowcase";

export default () => {
  const { t } = useTranslation("client\\components\\loggedInHome\\HobbyTopics");

  const title = t("Popular hobbies");
  const hobbyTopics: Topic[] = [
    {
      image: sportsImage,
      text: t("Movement"),
      path: onlineClassesPath("movement")
    },
    {
      image: performanceImage,
      text: t("Performance"),
      path: onlineClassesPath("performance-art")
    },
    {
      image: artImage,
      text: t("Arts"),
      path: onlineClassesPath("arts-and-crafts")
    },
    {
      image: travelImage,
      text: t("Travel"),
      path: onlineClassesPath("travel")
    },
    {
      image: animalsImage,
      text: t("Animals"),
      path: onlineClassesPath("animals")
    },
    {
      image: chessImage,
      text: t("Chess"),
      path: onlineClassesPath("chess")
    },
    {
      image: cookingImage,
      text: t("Cooking"),
      path: onlineClassesPath("cooking-and-baking")
    },
    {
      image: codeImage,
      text: t("Coding"),
      path: onlineClassesPath("coding-and-tech")
    }
  ];
  const sectionTrackingName = "hobby_topics";
  const buttonTrackingName = "hobby_topic";
  const imageTrackingName = "hobby-topic-image";

  return TopicsShowcase({
    title,
    topics: hobbyTopics,
    sectionTrackingName,
    buttonTrackingName,
    imageTrackingName
  });
};
